@if (vm$ | async; as vm) {
  @if (vm.showOverlay) {
    <section class="fiscal-question">
      <div class="fiscal-question__panel">
        @if (vm.showQuestion) {
          <mat-icon class="fiscal-question__icon">receipt_long</mat-icon>
          <h1>Czy nabijasz zamówienia na kasę fiskalną?</h1>
          @if (vm.hasError) {
            <p class="fiscal-question__error">
              Nie udało się zapisać odpowiedzi. Spróbuj ponownie.
            </p>
          }
          <div class="fiscal-question__actions">
            <button
              mat-flat-button
              color="primary"
              type="button"
              [disabled]="vm.isSaving"
              (click)="answerYes(vm.organizationId)"
              >
              Tak
            </button>
            <button
              mat-stroked-button
              type="button"
              [disabled]="vm.isSaving"
              (click)="answerNo(vm.organizationId)"
              >
              Nie
            </button>
          </div>
        } @else {
          <mat-icon class="fiscal-question__icon fiscal-question__icon--success"
            >check_circle</mat-icon
            >
            <h1>Dziękuję za odpowiedź!</h1>
          }
        </div>
      </section>
    }
  }
